import { render, staticRenderFns } from "./DvPropsWrapper.vue?vue&type=template&id=6a5c7d07&scoped=true"
import script from "./DvPropsWrapper.vue?vue&type=script&lang=js"
export * from "./DvPropsWrapper.vue?vue&type=script&lang=js"
import style0 from "./DvPropsWrapper.vue?vue&type=style&index=0&id=6a5c7d07&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5c7d07",
  null
  
)

export default component.exports